import { useNavigation } from "@app/lib/navigation";
import { adminPaths } from "@app/routing/adminPaths";
import { Modal } from "@design-system/Modal";
import { type FC, useState } from "react";
import { DeleteProjectModalContent } from "./DeleteProjectModalContent";
import { EditProjectModalContent } from "./EditProjectModalContent";

export const EditOrDeleteProjectModal: FC<{
    open: boolean;
    onOpenChange: (open: boolean) => void;
    projectId?: string;
}> = ({ open, onOpenChange, projectId }) => {
    const [currentModal, setCurrentModal] = useState<"edit" | "delete">("edit");
    const handleDelete = () => {
        setCurrentModal("delete");
    };
    const { navigateFromHome } = useNavigation();
    const handleDeleted = () => {
        navigateFromHome(adminPaths.frameworks);
        handleOpenChange(false);
    };
    const handleEdited = () => {
        handleOpenChange(false);
    };

    const handleOpenChange = (open: boolean) => {
        onOpenChange(open);
        setCurrentModal("edit");
    };

    return (
        <Modal open={open} onOpenChange={handleOpenChange}>
            <Modal.Overlay centerContent>
                {!projectId ? null : currentModal === "edit" ? (
                    <EditProjectModalContent
                        projectId={projectId}
                        onDelete={handleDelete}
                        onEdited={handleEdited}
                    />
                ) : (
                    <DeleteProjectModalContent
                        onDeleted={handleDeleted}
                        projectId={projectId}
                    />
                )}
            </Modal.Overlay>
        </Modal>
    );
};
